import { useQuery } from '@tanstack/react-query';
import { impersonationService } from '../../services/impersonationService';
import { RequestAuditResponse } from '../../types/Impersonation';
import { impersonationKeys } from './useImpersonationSessionQuery';

export const requestAuditKeys = {
  byRequest: (requestId: number) =>
    [...impersonationKeys.all, 'request-audit', requestId] as const,
};

export const useRequestAuditQuery = (
  requestId: number | undefined,
  isAdmin: boolean,
) => {
  return useQuery<RequestAuditResponse>({
    queryKey: requestAuditKeys.byRequest(requestId!),
    queryFn: () => impersonationService.getImpersonationAudit(requestId!),
    enabled: isAdmin && requestId !== undefined,
    staleTime: 5 * 60 * 1000,
  });
};
